import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  nl: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.auto": "Auto",
      "nav.tarieven": "Tarieven",
      "nav.theoriecursus": "Theoriecursus",
      "nav.contact": "Contact",
      "nav.english": "English",
      "nav.studentPortal": "Student Portal",
      
      // Hero Section
      "hero.title": "Nog niet begonnen met rijlessen?",
      "hero.highlight1": "Hoog slagingspercentage",
      "hero.highlight2": "Gespreid betalen is mogelijk",
      "hero.highlight3": "Ervaren rij-instructeurs",
      
      // Introduction Section
      "intro.title": "Rijlessen in Amsterdam e.o.",
      "intro.description": "Universaldrive is een van de betere rijscholen sinds 2002. We hebben in de loop der jaren een betrouwbare en professionele naam opgebouwd onder de vele tevreden cursisten. We zullen er daarom voor zorgen dat je een passende opleiding kiest door middel van een proefles en dat je na het afronden van je opleiding, zo vlot mogelijk, verkeersveilig en zelfstandig deel kunt nemen aan het verkeer.",
      "intro.button": "Proefles Plannen",
      
      // Services Section
      "services.title": "Services",
      "services.autorijles.title": "Autorijles",
      "services.autorijles.description": "Vakkundige instructeurs en instructrices begeleiden je op plezierige wijze naar je doel: het halen van je rijbewijs en bovenal het zelfstandig goed, veilig en vlot leren autorijden.",
      "services.autorijles.button": "Meer informatie",
      "services.expaten.title": "Expaten",
      "services.expaten.description": "Welkom in Nederland! Heb je (lang) niet gereden? Maak je geen zorgen. Met onze opfris rijlessen helpen we je snel weer op de weg. Heb je al een buitenlands rijbewijs? In sommige gevallen kunt u deze inwisselen voor een Nederlandse rijbewijs. Stuur ons een bericht.",
      "services.expaten.button": "Stuur een bericht",
      "services.theorie.title": "Theorie",
      "services.theorie.description": "Wij adviseren om naast je praktijkles meteen te beginnen met de theorie. Dat is immers de basis waarmee je in het verkeer situaties kunt beoordelen en inschatten.",
      "services.theorie.button": "Theoriecursus",
      
      // Technologies Section
      "technologies.title": "Rijlessen in Amsterdam e.o. Sinds 2002",
      "technologies.description": "Op zoek naar de beste rijschool in Amsterdam en omstreken? Dan ben je bij ons aan het juiste adres. Autorijbewijs halen is misschien wel de meest gewilde doelstelling onder de jeugd van tegenwoordig. Voor de een is het van belang voor het werk, voor de ander vanwege economische redenen voor andere opent het weer andere wegen.",
      "technologies.kpi.founded": "Opgericht",
      "technologies.kpi.years": "Jaar ervaring",
      "technologies.kpi.happy_customers": "Tevreden klanten",
      "technologies.best_driving_school": "Beste rijschool van Amsterdam",
      
      // Tariffs
      "tariffs.title": "AUTO Tarieven",
      "tariffs.manual.title": "Handschakel",
      "tariffs.manual.package.title": "Handschakel Rijbewijs",
      "tariffs.automatic.package.title": "Automaat Rijbewijs",
      "tariffs.automatic.title": "Automaat",
      // Loose prices heading (NL)
      "tariffs.individual.heading": "Onze losse prijzen",
      // Creative names for automatic packages (NL)
      "tariffs.automatic.packages.name_40": "Marathon Meester",
      "tariffs.automatic.packages.name_30": "Wegheld",
      "tariffs.automatic.packages.name_20": "Snelspoor",
      "tariffs.automatic.packages.name_10": "Snelle Kick-off",
      // Creative names for manual packages
      "tariffs.manual.packages.name_40": "Marathon Meester",
      "tariffs.manual.packages.name_30": "Wegheld",
      "tariffs.manual.packages.name_20": "Snelspoor",
      "tariffs.manual.packages.name_15": "Slimme Start",
      "tariffs.manual.packages.name_10": "Snelle Kick-off",
      "tariffs.manual.packages.name_retake": "Examen Comeback",
      "tariffs.benefits.high_pass_rate": "Hoog slagingspercentage",
      "tariffs.benefits.installment_payment": "Gespreid betalen is mogelijk",
      "tariffs.benefits.experienced_instructors": "Ervaren rij-instructeurs",
      
      "tariffs.packages.40_lessons": "40 rijlessen",
      "tariffs.packages.30_lessons": "30 rijlessen",
      "tariffs.packages.20_lessons": "20 rijlessen",
      "tariffs.packages.15_lessons": "15 rijlessen",
      "tariffs.packages.10_lessons": "10 rijlessen",
      "tariffs.packages.5_lessons": "5 rijlessen",
      "tariffs.packages.60_minutes": "60 minuten",
      "tariffs.packages.flexible": "Flexibel",
      "tariffs.packages.cbr_exam": "CBR examen",
      "tariffs.packages.choose": "Kiezen",
      "tariffs.packages.you_decide": "Jij bepaalt",
      "tariffs.packages.retake_package": "Herexamen Pakket",
      
      "tariffs.individual.title": "AUTO LOSSE PRIJZEN",
      "tariffs.individual.lesson": "Les",
      "tariffs.individual.price": "Prijs",
      "tariffs.individual.exam": "Examen",
      "tariffs.individual.trial_lesson": "Proefles",
      "tariffs.individual.free": "Gratis",
      "tariffs.individual.lesson_60": "Rijles 60 minuten",
      "tariffs.individual.lesson_90": "Rijles 90 minuten",
      "tariffs.individual.lesson_120": "Rijles 120 minuten",
      "tariffs.individual.ttt_exam": "T.T.T. tussentijdse toets CBR",
      "tariffs.individual.cbr_exam": "CBR examen",
      "tariffs.individual.anxiety_exam": "Faalangst examen",
      "tariffs.individual.bnor_exam": "BNOR examen",

      // Tariffs Modal (NL)
      "tariffs.modal.title": "Pakket Aanvragen - {{name}}",
      "tariffs.modal.default_title_name": "Rijlessen",
      "tariffs.modal.loading": "Even geduld alstublieft...",
      "tariffs.modal.selected_package": "Geselecteerd pakket:",
      "tariffs.modal.included": "Inclusief:",
      "tariffs.modal.name": "Naam",
      "tariffs.modal.phone": "Telefoon",
      "tariffs.modal.placeholders.name": "Uw naam",
      "tariffs.modal.placeholders.phone": "Uw telefoonnummer",
      "tariffs.modal.validation.name_min": "Naam moet minimaal 2 karakters bevatten",
      "tariffs.modal.validation.name_max": "Naam mag maximaal 25 karakters bevatten",
      "tariffs.modal.validation.phone_invalid": "Voer een geldig Nederlands telefoonnummer in",
      "tariffs.modal.email_intro": "Tariefkeuze op de tarievenpagina",
      "tariffs.modal.customer_details": "Klantgegevens:",
      "tariffs.modal.package": "Pakket",
      "tariffs.modal.price": "Prijs",
      "tariffs.modal.details": "Details",
      "tariffs.modal.email_subject": "Er is een tarief gekozen ({{price}}) - {{name}}",
      "tariffs.modal.success_message": "Bedankt voor je aanvraag {{name}}! Uw aanvraag is succesvol verzonden! Ons team neemt binnenkort contact met je op!",
      "tariffs.modal.errors.antibot_failed": "Bevestig alstublieft dat u geen robot bent en probeer opnieuw.",
      "tariffs.modal.errors.rate_limit": "Je hebt de indieningslimiet bereikt. Neem contact met ons op via telefoon of WhatsApp.",
      "tariffs.modal.errors.generic": "Er is een fout opgetreden. Probeer het later opnieuw.",
      "tariffs.modal.antibot_prompt": "Anti-bot check: wat is {{a}} + {{b}}?",
      "tariffs.modal.buttons.ok": "OK",
      "tariffs.modal.buttons.cancel": "Annuleren",
      "tariffs.modal.buttons.send": "Versturen",
      
      // Auto Page
      "auto.hero.title": "Jij wilt toch ook zelf achter het stuur kunnen?",
      "auto.hero.button": "Proefles Plannen",
      "auto.benefits.high_pass": "Hoog slagingspercentage",
      "auto.benefits.installment": "Gespreid betalen is mogelijk",
      "auto.benefits.experienced": "Ervaren rij-instructeurs",
      "auto.details.title": "Starten met je rijbewijs",
      "auto.details.intro": "Bent u op zoek naar een professioneel autorijschool in Amsterdam?",
      "auto.details.description": "Volg gratis bij ons je eerste autorijles (proefles)! Rijschool Universaldrive geeft autorijlessen in Amsterdam. Bij Universaldrive begeleiden vakkundige instructeurs en instructrices je op plezierige wijze naar je doel: het halen van het autorijbewijs en bovenal het zelfstandig goed, veilig en vlot leren autorijden.",
      "auto.details.more_text": "Er wordt een persoonlijk plan opgesteld na de eerste proefles. Daarbij wordt gekeken naar jouw mogelijkheden en specifieke wensen. We kunnen dan gelijk een inschatting maken van het benodigde aantal lessen.\n\nAutorijlessen krijg je in een uitstekende auto met een vaste instructeur of instructrice. Desgewenst halen we je op van huis en wordt je door de volgende leerling ook weer thuisgebracht. Zo rij je in diverse verkeersgebieden en je leert daarbij ook nog eens extra van elkaar.\n\nNatuurlijk zullen we ook in het examengebied oefenen om je vertrouwd te maken met de situaties die je tijdens het examen kunt tegenkomen.",
      "auto.details.read_more": "Lees meer",
      "auto.details.read_less": "Lees minder",
      "auto.packages.title": "Kies jouw pakket!",
      "auto.packages.pro_max": "PRO MAX",
      "auto.packages.pro": "PRO",
      "auto.packages.premium": "PREMIUM",
      "auto.packages.lessons_40": "40 uur rijles",
      "auto.packages.lessons_30": "30 uur rijles",
      "auto.packages.lessons_20": "20 uur rijles",
      "auto.packages.cbr_exam": "CBR Examen inbegrepen",
      "auto.packages.trial_button": "Proefles",
      "auto.callback.title": "Bel mij Terug",
      "auto.callback.name": "Naam",
      "auto.callback.phone": "Telefoon",
      "auto.callback.submit": "Sturen",
      "auto.callback.auto": "Automaat ",
      "auto.callback.motor": "Handschakel",
      "auto.callback.taxi": "Taxi",
      "auto.callback.theory": "Theoriecursus",

      // Reviews Section
      "reviews.title": "Reviews",
      "reviews.description": "Bekijk wat onze studenten van ons vinden.",
      "reviews.google": "Google Reviews",
      "reviews.facebook": "Facebook Reviews",
      
      // Demo Lesson Form
      "demo.title": "Proef Les Plannen",
      "demo.name": "Naam",
      "demo.phone": "Telephone",
      "demo.email": "E-mail",
      "demo.service": "Dienst",
      "demo.service_auto_manual": "Handschakel rijbewijs",
      "demo.service_auto_automatic": "Automatic licence",
      "demo.service_theory": "Theoriecursus",
      "demo.submit": "Versturen",
      "demo.error": "Vul alle vereiste velden correct in.",
      "demo.success": "Uw aanvraag is succesvol verzonden! Ons team neemt binnenkort contact met je op!",
      "demo.error_general": "Er is iets misgegaan. Probeer het opnieuw.",
        "common.show_all": "Alles tonen",
        "common.show_less": "Minder tonen",
        "common.show_more": "Meer tonen",
      // Portal localization (NL)
      "portal.calendar.filter.all": "Alles",
      "portal.calendar.filter.booked": "Geboekt",
      "portal.calendar.filter.available": "Beschikbaar",
      "portal.calendar.daily_limit": "Daglimiet bereikt voor deze datum ({{count}}/{{cap}})",
      "portal.calendar.no_lessons": "Geen lessen.",
      "portal.calendar.no_booked": "Geen geboekte lessen.",
      "portal.calendar.no_available": "Geen beschikbare lessen.",
      "portal.calendar.no_unbooked": "Geen ongeboekte lessen.",
      "portal.calendar.day": "Dag",
      "portal.calendar.available": "Beschikbaar",
      "portal.calendar.unbooked": "Ongeboekt",
      "portal.calendar.minutes": "minuten",
      "portal.calendar.booked_lesson": "Geboekte les",
      "portal.calendar.available_slot": "Beschikbare slot",
      "portal.calendar.unbooked_slot": "Ongeboekte slot",
      "portal.calendar.book": "Boeken",
      "portal.calendar.booking": "Bezig met boeken…",
      "portal.calendar.open_details": "Lesdetails openen",
      "portal.calendar.completed": "Voltooid",
      "portal.calendar.nav.prev": "Vorige",
      "portal.calendar.nav.today": "Vandaag",
      "portal.calendar.nav.next": "Volgende",
      "portal.calendar.view.week": "Week",
      "portal.calendar.view.day": "Dag",
      "portal.calendar.status.completed": "Voltooid",
      "portal.calendar.status.passed": "Geslaagd",
      "portal.calendar.status.failed": "Gezakt",

      "portal.common.list": "Lijst",
      "portal.common.calendar": "Kalender",
      "portal.common.loading": "Laden…",

      "portal.exams.title": "Examens",
      "portal.exams.subtitle": "Je geplande en vorige examens",
      "portal.exams.refresh": "Vernieuwen",
      "portal.exams.next_exam": "Volgend examen",
      "portal.exams.next_exam_sub": "Als je een examen hebt gepland, verschijnt deze hier",
      "portal.exams.no_upcoming": "Geen aankomend examen.",
      "portal.exams.history": "Geschiedenis",
      "portal.exams.history_sub": "Vorige examens",
      "portal.exams.none": "Nog geen examens.",
      "portal.exams.tap_details": "Tik voor details",
      "portal.exams.status.upcoming": "AANKOMEND",
      "portal.exams.status.completed": "VOLTOOID",
      "portal.exams.status.passed": "GESLAAGD",
      "portal.exams.status.failed": "GEZAKT",

      "portal.lessons.title": "Lessen",
      "portal.lessons.subtitle": "Bekijk je lessen en boek een nieuwe",
      "portal.lessons.tabs.booked": "Geboekt",
      "portal.lessons.tabs.available": "Beschikbaar",
      "portal.lessons.tabs.past": "Verleden",
      "portal.lessons.loading": "Lessen laden…",
      "portal.lessons.none_upcoming": "Geen aankomende lessen gepland.",
      "portal.lessons.teacher": "Instructeur:",
      "portal.lessons.your_note": "Jouw notitie:",
      "portal.lessons.cancel": "Annuleren",
      "portal.lessons.cancelling": "Annuleren…",
      "portal.lessons.exam": "Examen:",

      // Profile (NL)
      "portal.profile.title": "Profiel",
      "portal.profile.subtitle": "Beheer je persoonlijke gegevens en voorkeuren",
      "portal.profile.first_name": "Voornaam",
      "portal.profile.last_name": "Achternaam",
      "portal.profile.email": "E-mail",
      "portal.profile.phone": "Telefoon",
      "portal.profile.address": "Adres",
      "portal.profile.pickup_location": "Ophaallocatie",
      "portal.profile.preferred_teacher": "Voorkeursinstructeur",
      "portal.profile.language": "Taal",
      "portal.profile.theme": "Thema",
      "portal.profile.save": "Opslaan",
      "portal.profile.saving": "Opslaan…",
      "portal.profile.saved": "Opgeslagen!",
      "portal.profile.error": "Opslaan mislukt",
      "portal.profile.theme_updated": "Thema bijgewerkt naar {{theme}}",
      
      // Footer
      "footer.description": "Wij houden je graag op de hoogte over ontwikkelingen van UniversalDrive.",
      "footer.privacy": "Privacy Policy",
      "footer.cookies": "Cookie Policy",
      "footer.social_media": "🔗 Social Media:",
      "footer.contact_title": "📍 Contactgegevens",
      "footer.contact_description": "Autorijschool Universal, voor Amsterdam en omstreken",
      "footer.address": "Javastraat 112, 1094 HN Amsterdam",
      "footer.phone": "Tel: 06 16752832",
      "footer.email": "Email: info@universaldrive.nl",
      "footer.instagram": "Instagram: @universaldrive",
      "footer.facebook": "Facebook: UniversalDrive",
      "footer.phone_label": "Phone: +31 6 16752832",
      "footer.digid_title": "🔐 Machtig ons met DigiD",
      "footer.digid_description": "Klik hier om Universaldrive te machtigen met je DigiD.",
      "footer.digid_link": "CBR Machtigen",
      "footer.copyright": "&copy; Copyright Universal Drive. All rights reserved | Designed & Implemented by bigO Digital NL",
      
      // Tariff Modal
      "modal.title": "Pakket Aanvragen",
      "modal.selected_package": "Geselecteerd pakket:",
      "modal.includes": "Inclusief:",
      "modal.name_label": "Naam",
      "modal.phone_label": "Telefoon",
      "modal.name_placeholder": "Uw naam",
      "modal.phone_placeholder": "Uw telefoonnummer",
      "modal.cancel": "Annuleren",
      "modal.submit": "Versturen",
      "modal.loading": "Even geduld alstublieft...",
      "modal.success": "Bedankt voor je aanvraag {name}! Uw aanvraag is succesvol verzonden! Ons team neemt binnenkort contact met je op!",
      "modal.error": "Er is een fout opgetreden. Probeer het later opnieuw.",
      "modal.ok": "OK",
      "modal.name_error_min": "Naam moet minimaal 2 karakters bevatten",
      "modal.name_error_max": "Naam mag maximaal 25 karakters bevatten",
      "modal.phone_error": "Voer een geldig Nederlands telefoonnummer in",
      
      // WhatsApp Button
      "whatsapp.title": "Contact ons via WhatsApp",
      "whatsapp.message": "Hallo! Ik ben geïnteresseerd in rijlessen bij UniversalDrive.",

      // Meta
      "meta.title": "Home - Beste rijschool van Amsterdam",
      "meta.description": "Home - Beste rijschool van Amsterdam"
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.auto": "Car",
      "nav.tarieven": "Rates",
      "nav.theoriecursus": "Theory Course",
      "nav.contact": "Contact",
      "nav.english": "English",
      "nav.studentPortal": "Student Portal",
      
      // Hero Section
      "hero.title": "Haven't started driving lessons yet?",
      "hero.highlight1": "High pass rate",
      "hero.highlight2": "Installment payments possible",
      "hero.highlight3": "Experienced driving instructors",
      
      // Introduction Section
      "intro.title": "Driving lessons in Amsterdam and surroundings",
      "intro.description": "Universaldrive is one of the better driving schools since 2002. Over the years, we have built a reliable and professional reputation among the many satisfied students. We will therefore ensure that you choose a suitable training program through a trial lesson and that after completing your training, you can participate in traffic as smoothly as possible, safely and independently.",
      "intro.button": "Schedule Trial Lesson",
      
      // Services Section
      "services.title": "Services",
      "services.autorijles.title": "Car Driving Lessons",
      "services.autorijles.description": "Skilled instructors guide you in a pleasant way towards your goal: getting your driver's license and above all learning to drive independently, safely and smoothly.",
      "services.autorijles.button": "More information",
      "services.expaten.title": "Expats",
      "services.expaten.description": "Welcome to the Netherlands! Haven't driven for a (long) time? Don't worry. With our refresher driving lessons we'll help you get back on the road quickly. Do you already have a foreign driver's license? In some cases you can exchange it for a Dutch driver's license. Send us a message.",
      "services.expaten.button": "Send a message",
      "services.theorie.title": "Theory",
      "services.theorie.description": "We advise you to start with theory immediately alongside your practical lessons. That is, after all, the basis with which you can assess and estimate situations in traffic.",
      "services.theorie.button": "Theory Course",
      
      // Technologies Section
      "technologies.title": "Driving lessons in Amsterdam and surroundings. Since 2002",
      "technologies.description": "Looking for the best driving school in Amsterdam and surroundings? Then you've come to the right place. Getting a car driver's license is perhaps the most desired goal among today's youth. For some it's important for work, for others for economic reasons, for others it opens up other paths.",
      "technologies.kpi.founded": "Founded",
      "technologies.kpi.years": "Years experience",
      "technologies.kpi.happy_customers": "Happy customers",
      "technologies.best_driving_school": "Best driving school in Amsterdam",
      
      // Tariffs
      "tariffs.title": "CAR Tariffs",
      "tariffs.manual.title": "Manual Tariffs",
      "tariffs.manual.package.title": "Manual License",
      "tariffs.automatic.package.title": "Automatic License",
        "tariffs.automatic.title": "Automatic Tariffs",
        // Loose prices heading (EN)
        "tariffs.individual.heading": "Our Loose Prices",
        // Creative names for automatic packages (EN)
        "tariffs.automatic.packages.name_40": "Marathon Master",
        "tariffs.automatic.packages.name_30": "Road Hero",
        "tariffs.automatic.packages.name_20": "Fast Track",
        "tariffs.automatic.packages.name_10": "Quick Kickoff",
        // Creative names for manual packages (EN)
        "tariffs.manual.packages.name_40": "Marathon Master",
        "tariffs.manual.packages.name_30": "Road Hero",
        "tariffs.manual.packages.name_20": "Fast Track",
        "tariffs.manual.packages.name_15": "Smart Start",
        "tariffs.manual.packages.name_10": "Quick Kickoff",
        "tariffs.manual.packages.name_retake": "Exam Comeback",
        "common.show_less": "Show less",
        "common.show_more": "Show more",

      // Tariffs Modal (EN)
      "tariffs.modal.title": "Request Package - {{name}}",
      "tariffs.modal.default_title_name": "Driving lessons",
      "tariffs.modal.loading": "Please wait...",
      "tariffs.modal.selected_package": "Selected package:",
      "tariffs.modal.included": "Included:",
      "tariffs.modal.name": "Name",
      "tariffs.modal.phone": "Phone",
      "tariffs.modal.placeholders.name": "Your name",
      "tariffs.modal.placeholders.phone": "Your phone number",
      "tariffs.modal.validation.name_min": "Name must be at least 2 characters",
      "tariffs.modal.validation.name_max": "Name may be at most 25 characters",
      "tariffs.modal.validation.phone_invalid": "Please enter a valid Dutch phone number",
      "tariffs.modal.email_intro": "Tariff selection from the tariffs page",
      "tariffs.modal.customer_details": "Customer details:",
      "tariffs.modal.package": "Package",
      "tariffs.modal.price": "Price",
      "tariffs.modal.details": "Details",
      "tariffs.modal.email_subject": "A package was selected ({{price}}) - {{name}}",
      "tariffs.modal.success_message": "Thank you for your request {{name}}! Your request was sent successfully! Our team will contact you soon!",
      "tariffs.modal.errors.antibot_failed": "Please confirm you are not a robot and try again.",
      "tariffs.modal.errors.rate_limit": "You have reached the submission limit. Please contact us by phone or WhatsApp.",
      "tariffs.modal.errors.generic": "An error occurred. Please try again later.",
      "tariffs.modal.antibot_prompt": "Anti-bot check: what is {{a}} + {{b}}?",
      "tariffs.modal.buttons.ok": "OK",
      "tariffs.modal.buttons.cancel": "Cancel",
      "tariffs.modal.buttons.send": "Send",

      // Portal localization (EN)
      "portal.calendar.filter.all": "All",
      "portal.calendar.filter.booked": "Booked",
      "portal.calendar.filter.available": "Available",
      "portal.calendar.daily_limit": "Daily limit reached for this date ({{count}}/{{cap}})",
      "portal.calendar.no_lessons": "No lessons.",
      "portal.calendar.no_booked": "No booked lessons.",
      "portal.calendar.no_available": "No available lessons.",
      "portal.calendar.no_unbooked": "No unbooked lessons.",
      "portal.calendar.day": "Day",
      "portal.calendar.available": "Available",
      "portal.calendar.unbooked": "Unbooked",
      "portal.calendar.minutes": "minutes",
      "portal.calendar.booked_lesson": "Booked lesson",
      "portal.calendar.available_slot": "Available slot",
      "portal.calendar.unbooked_slot": "Unbooked slot",
      "portal.calendar.book": "Book",
      "portal.calendar.booking": "Booking…",
      "portal.calendar.open_details": "Open lesson details",
      "portal.calendar.completed": "COMPLETED",
      "portal.calendar.nav.prev": "Previous",
      "portal.calendar.nav.today": "Today",
      "portal.calendar.nav.next": "Next",
      "portal.calendar.view.week": "Week",
      "portal.calendar.view.day": "Day",
      "portal.calendar.status.completed": "COMPLETED",
      "portal.calendar.status.passed": "PASSED",
      "portal.calendar.status.failed": "FAILED",

      "portal.lessons.title": "Lessons",
      "portal.lessons.subtitle": "Review your lessons and book a new one",
      "portal.lessons.tabs.booked": "Booked",
      "portal.lessons.tabs.available": "Available",
      "portal.lessons.tabs.past": "Past",
      "portal.lessons.loading": "Loading lessons…",
      "portal.lessons.none_upcoming": "No upcoming lessons scheduled.",
      "portal.lessons.teacher": "Teacher:",
      "portal.lessons.your_note": "Your note:",
      "portal.lessons.cancel": "Cancel",
      "portal.lessons.cancelling": "Cancelling…",
      "portal.lessons.exam": "Exam:",

      // Profile (EN)
      "portal.profile.title": "Profile",
      "portal.profile.subtitle": "Manage your personal details and preferences",
      "portal.profile.first_name": "First name",
      "portal.profile.last_name": "Last name",
      "portal.profile.email": "E-mail",
      "portal.profile.phone": "Phone",
      "portal.profile.address": "Address",
      "portal.profile.pickup_location": "Pickup location",
      "portal.profile.preferred_teacher": "Preferred instructor",
      "portal.profile.language": "Language",
      "portal.profile.theme": "Theme",
      "portal.profile.save": "Save",
      "portal.profile.saving": "Saving…",
      "portal.profile.saved": "Saved!",
      "portal.profile.error": "Save failed",
      "portal.profile.theme_updated": "Theme updated to {{theme}}",

      "portal.common.list": "List",
      "portal.common.calendar": "Calendar",
      "tariffs.benefits.high_pass_rate": "High passing rate",
      "tariffs.benefits.installment_payment": "Installment payment is possible",
      "tariffs.benefits.experienced_instructors": "Experienced driving instructors",
      
      "tariffs.packages.40_lessons": "40 driving lessons",
      "tariffs.packages.30_lessons": "30 driving lessons",
      "tariffs.packages.20_lessons": "20 driving lessons",
      "tariffs.packages.15_lessons": "15 driving lessons",
      "tariffs.packages.10_lessons": "10 driving lessons",
      "tariffs.packages.5_lessons": "5 driving lessons",
      "tariffs.packages.60_minutes": "60 minutes",
      "tariffs.packages.flexible": "Flexible",
      "tariffs.packages.cbr_exam": "CBR exam",
      "tariffs.packages.choose": "Choose",
      "tariffs.packages.you_decide": "You decide",
      "tariffs.packages.retake_package": "Retake Package",
      
      "tariffs.individual.title": "CAR INDIVIDUAL PRICES",
      "tariffs.individual.lesson": "Lesson",
      "tariffs.individual.price": "Price",
      "tariffs.individual.exam": "Exam",
      "tariffs.individual.trial_lesson": "Trial lesson",
      "tariffs.individual.free": "Free",
      "tariffs.individual.lesson_60": "Driving lesson 60 minutes",
      "tariffs.individual.lesson_90": "Driving lesson 90 minutes",
      "tariffs.individual.lesson_120": "Driving lesson 120 minutes",
      "tariffs.individual.ttt_exam": "T.T.T. intermediate test CBR",
      "tariffs.individual.cbr_exam": "CBR exam",
      "tariffs.individual.anxiety_exam": "Test anxiety exam",
      "tariffs.individual.bnor_exam": "BNOR exam",
      
      // Auto Page
      "auto.hero.title": "Don't you also want to be able to drive yourself?",
      "auto.hero.button": "Schedule Trial Lesson",
      "auto.benefits.high_pass": "High passing rate",
      "auto.benefits.installment": "Installment payment is possible",
      "auto.benefits.experienced": "Experienced driving instructors",
      "auto.details.title": "Getting started with your driver's license",
      "auto.details.intro": "Are you looking for a professional driving school in Amsterdam?",
      "auto.details.description": "Follow your first driving lesson (trial lesson) with us for free! Driving school Universaldrive provides driving lessons in Amsterdam. At Universaldrive, skilled instructors guide you in a pleasant way towards your goal: getting your driver's license and above all learning to drive independently, safely and smoothly.",
      "auto.details.more_text": "A personal plan is drawn up after the first trial lesson. Your possibilities and specific wishes are taken into account. We can then immediately make an estimate of the required number of lessons.\n\nYou get driving lessons in an excellent car with a permanent instructor. If desired, we pick you up from home and you will also be taken home again by the next student. This way you drive in various traffic areas and you also learn extra from each other.\n\nOf course we will also practice in the exam area to familiarize you with the situations you may encounter during the exam.",
      "auto.details.read_more": "Read more",
      "auto.details.read_less": "Read less",
      "auto.packages.title": "Choose your package!",
      "auto.packages.pro_max": "PRO MAX",
      "auto.packages.pro": "PRO",
      "auto.packages.premium": "PREMIUM",
      "auto.packages.lessons_40": "40 hours driving lessons",
      "auto.packages.lessons_30": "30 hours driving lessons",
      "auto.packages.lessons_20": "20 hours driving lessons",
      "auto.packages.cbr_exam": "CBR Exam included",
      "auto.packages.trial_button": "Trial lesson",
      "auto.callback.title": "Call me back",
      "auto.callback.name": "Name",
      "auto.callback.phone": "Phone",
      "auto.callback.submit": "Send",
      "auto.callback.auto": "Manual",
      "auto.callback.motor": "Automatic",
      "auto.callback.taxi": "Taxi",
      "auto.callback.theory": "Theory course",
      
      // Reviews Section
      "reviews.title": "Reviews",
      "reviews.description": "See what our students think of us.",
      "reviews.google": "Google Reviews",
      "reviews.facebook": "Facebook Reviews",
      
      // Demo Lesson Form
      "demo.title": "Schedule a Trial",
      "demo.name": "Name",
      "demo.phone": "Phone",
      "demo.email": "E-mail",
      "demo.service": "License",
      "demo.service_auto_manual": "Handschakel",
      "demo.service_auto_automatic": "Automatic",
      "demo.service_theory": "Theory Course",
      "demo.submit": "Send",
      "demo.error": "Please fill in all required fields correctly.",
      "demo.success": "Your request has been sent successfully! Our team will contact you soon!",
      "demo.error_general": "Something went wrong. Please try again.",
      
      // Footer
      "footer.description": "We would like to keep you informed about developments at UniversalDrive.",
      "footer.privacy": "Privacy Policy",
      "footer.cookies": "Cookie Policy",
      "footer.social_media": "🔗 Social Media:",
      "footer.contact_title": "📍 Contact Information",
      "footer.contact_description": "Universal Driving School, for Amsterdam and surroundings",
      "footer.address": "Javastraat 112, 1094 HN Amsterdam",
      "footer.phone": "Tel: 06 16752832",
      "footer.email": "Email: info@universaldrive.nl",
      "footer.instagram": "Instagram: @universaldrive",
      "footer.facebook": "Facebook: UniversalDrive",
      "footer.phone_label": "Phone: +31 6 16752832",
      "footer.digid_title": "🔐 Authorize us with DigiD",
      "footer.digid_description": "Click here to authorize Universaldrive with your DigiD.",
      "footer.digid_link": "CBR Authorization",
      "footer.copyright": "&copy; Copyright Universal Drive. All rights reserved | Designed & Implemented by bigO Digital NL",
      
      // Tariff Modal
      "modal.title": "Request Package",
      "modal.selected_package": "Selected package:",
      "modal.includes": "Includes:",
      "modal.name_label": "Name",
      "modal.phone_label": "Phone",
      "modal.name_placeholder": "Your name",
      "modal.phone_placeholder": "Your phone number",
      "modal.cancel": "Cancel",
      "modal.submit": "Send",
      "modal.loading": "Please wait...",
      "modal.success": "Thank you for your request {name}! Your request has been sent successfully! Our team will contact you soon!",
      "modal.error": "An error occurred. Please try again later.",
      "modal.ok": "OK",
      "modal.name_error_min": "Name must contain at least 2 characters",
      "modal.name_error_max": "Name may contain at most 25 characters",
      "modal.phone_error": "Enter a valid Dutch phone number",
      
      // WhatsApp Button
      "whatsapp.title": "Contact us via WhatsApp",
      "whatsapp.message": "Hello! I am interested in driving lessons at UniversalDrive.",

      // Meta
      "meta.title": "Home - Best driving school in Amsterdam",
      "meta.description": "Home - Best driving school in Amsterdam",

      // Common (EN)
      "portal.common.loading": "Loading…",

      // Exams (EN)
      "portal.exams.title": "Exams",
      "portal.exams.subtitle": "Your planned and past exams",
      "portal.exams.refresh": "Refresh",
      "portal.exams.next_exam": "Next Exam",
      "portal.exams.next_exam_sub": "If you have a booked exam coming up, it appears here",
      "portal.exams.no_upcoming": "No upcoming exam.",
      "portal.exams.history": "History",
      "portal.exams.history_sub": "Past exams",
      "portal.exams.none": "No exams yet.",
      "portal.exams.tap_details": "Tap for details",
      "portal.exams.status.upcoming": "UPCOMING",
      "portal.exams.status.completed": "COMPLETED",
      "portal.exams.status.passed": "PASSED",
      "portal.exams.status.failed": "FAILED"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'nl', // Default language is Dutch
    fallbackLng: 'nl',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

